import { ReactNode } from 'react';
import packageInfo from '../../package.json';
import { OverridedMixpanel } from 'mixpanel-browser';
import { Generic, Nullable } from '@ygoargentina/sdk/api/api.types';
import { UseMutateFunction } from '@tanstack/react-query';

export type ExcelRow = {
  value: string | number;
  span?: number;
  type?: string;
}[];

export type VoidFunction = () => void;

export type OnChangeEvent = {
  currentTarget: {
    name: string;
    value: string;
  };
};

export type WithDirty<T> = T & {
  dirty?: boolean;
};

export type NavItem = {
  component?: React.ForwardRefExoticComponent<
    React.RefAttributes<HTMLLIElement>
  >;
  name: string;
  icon?: ReactNode;
  route?: string;
  to?: string;
  permissionKey?: string;
  items?: NavItem[];
};

export const AppVersion = packageInfo.version;
/** `<version>.<build>`; el API lo loguea como `commitHash`. */
export const AppCommitHash = packageInfo.commitHash;

/**
 *  USERS
 */

export type SearchForm = {
  search: string;
  trashed?: number;
  status?: string;
};

export type WithDate<T = unknown> = T & {
  date: string;
};

export enum Env {
  Local = 'local',
  QA = 'qa',
  Production = 'production',
}

export type LogEvent = {
  eventName: string;
  eventData: Generic;
};

export type WithTrash<T> = T & {
  deletedAt: Nullable<string>;
};

export type ButtonRef = HTMLButtonElement | HTMLAnchorElement;

export type ForwardedModalProps = {
  open: (...args: unknown[]) => void;
  close: (...args: unknown[]) => void;
};

export type MyEvent = {
  detail: string;
};

export type MixPanel = OverridedMixpanel;

export enum EventKey {
  ScreenView = 'ScreenView',
  Logout = 'Logout',
  LogEvent = 'LogEvent',
}

export type GenericState = {
  resetStore: () => void;
};

export type WithCreation<P = unknown, T = unknown, CT = unknown> = P & {
  isCreation: boolean;
  mutation: {
    submit: UseMutateFunction<{ data: T }, Error, CT, unknown>;
    loading: boolean;
  };
};

export type WithRefetch<T> = T & {
  refetch: () => Promise<void>;
};
